<template>
    <div class="space-y-1 *:data-[slot='control']:mt-0">
        <slot :has-error="hasError" :error-id="errorId" />
        <Message v-if="error" :id="errorId" severity="error" variant="simple" role="alert">
            {{ error }}
        </Message>
    </div>
</template>

<script setup>
const props = defineProps({
    error: {
        type: String,
        default: ''
    }
})

const hasError = computed(() => !!props.error)

// ⚠️ IMPORTANT: stable ID (see note below)
const errorId = computed(() => (props.error ? 'error-first-name' : null))
</script>
